import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { CompaniesAppDataProviderFactory } from '../factory/CompaniesAppDataProviderFactory';
import { CompanyTypeData } from '../../../company/types/company-type-data';
import { CompaniesAppBaseDataProvider } from '../dataProvider/CompaniesAppBaseDataProvider';

export class CompaniesAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CompaniesAppDataProviderFactory;
  public dataProvider: CompaniesAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CompaniesAppDataProviderFactory(),
    });
  }

  public async getCompanyTypes(): Promise<CompanyTypeData[]> {
    return this.dataProvider.getCompanyTypes();
  }

  public async getNumberOfCompaniesInContainer(companyIds: Array<{ _id: string }>): Promise<number> {
    return this.dataProvider.getNumberOfCompaniesInContainer(companyIds);
  }

  public async removeCompanyRecords(companyIds: Array<{ _id: string }>): Promise<object> {
    return this.dataProvider.removeCompanyRecords(companyIds);
  }
}
